import React, { useEffect } from 'react';
import './App.css';
import Main from './components/main/main';
import 'bootstrap/dist/css/bootstrap.min.css';

import AppStore from './Utils/Appstore';
import { Provider } from 'react-redux';
import AppRoutes from './routes/appRoutes';

function App() {

  return (
    <>
        <AppRoutes />
    </>
  );
}

export default App;
